// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ub6Kk","label":"styles_label__1x1ZI"};